<template>
  <div class="check-box" :class="rootClasses">
    <input
      class="check-box__input"
      type="checkbox"
      v-model="checkboxValue"
      @change="handleChange(checkboxValue)"
      :disabled="handlingChange"
      :id="fieldName"
      :name="fieldName" />
    <label class="check-box__label" :for="fieldName">
      <span class="check-box__icon-container">
        <icon-check class="check-box__icon" />
      </span>
      <span class="check-box__label-text" v-html="fieldLabel" />
    </label>
    <button v-if="withToggle" class="check-box__toggle" @click="handleToggle">
      <icon-caret-down class="check-box__toggle-icon" />
    </button>
  </div>
</template>

<script lang="ts">
import IconCaretDown from '~/assets/icons/IconCaretDown.svg';
import IconCheck from '~/assets/icons/IconCheck.svg';

export default {
  emits: [
    'on-change',
    'on-toggle',
  ],
  components: {
    IconCaretDown,
    IconCheck,
  },
  props: {
    fieldName: String,
    fieldLabel: String,
    initialValue: Boolean,
    withToggle: Boolean,
    toggleOpen: Boolean,
    handlingChange: Boolean,
  },
  data() {
    return {
      checkboxValue: false,
    }
  },
  mounted() {
    this.checkboxValue = this.initialValue
  },
  computed: {
    rootClasses () {
      return {
        'check-box--with-toggle': this.withToggle,
        'check-box--toggle-open': this.toggleOpen,
        'check-box--checked': this.checkboxValue,
      }
    },
  },
  methods: {
    handleChange (newValue) {
      if (!this.handlingChange) {
        this.$emit('on-change', newValue);
      }
    },
    handleToggle () {
      this.$emit('on-toggle');
    },
  },
  watch: {
    initialValue(newValue) {
      this.checkboxValue = newValue
    }
  }
}
</script>

<style lang="scss">
@use "~/common/scss/helpers";

.check-box {
  $root: &;

  align-items: center;
  display: flex;
  gap: .5rem;
  margin-bottom: helpers.px-to-rem(8);

  &__input {
    display: none;
  }

  &__label {
    align-items: center;
    cursor: pointer;
    display: flex;
    gap: helpers.px-to-rem(10);
  }

  &__icon-container {
    align-items: center;
    background-color: #FFF;
    border: 1px solid #707070;
    border-radius: 2px;
    color: transparent;
    display: flex;
    flex: 0 0 helpers.px-to-rem(20);
    font-size: .7rem;
    height: helpers.px-to-rem(20);
    justify-content: center;
    transition: background-color .25s, border-color .25s, color .25s;
    width: helpers.px-to-rem(20);

    #{$root}__label:hover & {
      background-color: #707070;
      color: #FFF;
    }

    #{$root}--checked & {
      background-color: #000;
      border-color: #000;
      color: #FFF;
    }
  }

  &__toggle {
    align-items: center;
    display: flex;
    flex: 0 0 helpers.px-to-rem(20);
    height: helpers.px-to-rem(20);
    justify-content: center;
    margin-left: auto;
    width: helpers.px-to-rem(20);
  }

  &__toggle-icon {

    #{$root}--toggle-open & {
      transform: rotate(180deg);
    }
  }
}
</style>
